import React from 'react';
import { Footer, Navbar, P6, P7 } from '../Components';

const AboutUs = () => {
  return (
    <div>
      <Navbar bgColor={"black"} padding={5}/>
      <P6/>
      <P7/>
      <div>
        <div className="my-20 flex flex-col justify-center text-center">
            <p className="text-6xl mb-5">Our Core Values</p>
            <p className="text-2xl">We Practice what we preach</p>
        </div>
        <div className="flex flex-row justify-evenly mb-10">
          <div className="border" style={{width: "300px"}}>
            <svg className="ml-10 mt-20" preserveAspectRatio="xMidYMid meet" data-bbox="20.63 20.63 158.74 158.74" viewBox="20.63 20.63 158.74 158.74" height="70" width="70" xmlns="http://www.w3.org/2000/svg" data-type="color" role="presentation" aria-hidden="true" aria-labelledby="svgcid--awwz13-deh0x8"><title id="svgcid--awwz13-deh0x8"></title>
              <g>
                <path fill="#7E55F6" d="M86 56v28H59V56h27z" data-color="1"></path>
                <path fill="#7E55F6" d="M86 116v28H59v-28h27z" data-color="1"></path>
                <path d="M87.598 72.082V55.354H57.835v29.764h29.764V72.082zm-2.48 10.556H60.315V57.835h24.803v24.803zM20.63 20.63v158.74h158.74V20.63H20.63zm156.26 156.26H23.11V23.11h153.78v153.78zm-89.292-45.801v-16.207H57.835v29.764h29.764v-13.557zm-2.48 11.076H60.315v-24.803h24.803v24.803zm31.41-63.091-9.313-8.717 1.696-1.812 7.56 7.078 20.143-20.142 1.754 1.754-21.84 21.839zm1.941 55.549 20.143-20.142 1.754 1.754-21.839 21.84-9.313-8.717 1.696-1.812 7.559 7.077z" fill="#1D1D1B" data-color="2"></path>
              </g>
            </svg>
            <div className="ml-10 mt-5 mb-20">
              <p className="mb-5 text-2xl">Integrity</p>
              <p>I'm a paragraph. Click</p>
              <p>here to add your own</p>
              <p>text and edit me.</p>
            </div>
          </div>
          <div className="border" style={{width: "300px"}}>
            <svg className="ml-10 mt-20" preserveAspectRatio="xMidYMid meet" data-bbox="20.63 20.63 158.74 158.74" viewBox="20.63 20.63 158.74 158.74" height="70" width="70" xmlns="http://www.w3.org/2000/svg" data-type="color" role="presentation" aria-hidden="true" aria-labelledby="svgcid--legnbr-cbtcya"><title id="svgcid--legnbr-cbtcya"></title>
              <g>
                <path fill="#7E55F6" d="M91.746 85h-30l17.5-13.5 11.5-9.5 1 23z" data-color="1"></path>
                <path d="M139.685 60.315H91.167l-30.852 24.11v55.261h79.37V60.315zm-49.759 4.118v18.752H65.93l23.996-18.752zm47.279 72.772h-74.41V85.634l.155-.121v.152h29.456v-22.87h44.799v74.41zM20.63 20.63v158.74h158.74V20.63H20.63zm156.26 156.26H23.11V23.11h153.78v153.78zm-70.745-68.374H76.19v-2.48h29.955v2.48zm17.667 0h-6.913v-2.48h6.913v2.48zM76.19 119.098h47.623v2.48H76.19v-2.48z" fill="#1D1D1B" data-color="2"></path>
              </g>
            </svg>
            <div className="ml-10 mt-5 mb-20">
              <p className="mb-5 text-2xl">Accountability</p>
              <p>I'm a paragraph. Click</p>
              <p>here to add your own</p>
              <p>text and edit me.</p>
            </div>
          </div>
          <div className="border" style={{width: "300px"}}>
            <svg className="ml-10 mt-20" preserveAspectRatio="xMidYMid meet" data-bbox="20.63 20.63 158.74 158.74" viewBox="20.63 20.63 158.74 158.74" height="70" width="70" xmlns="http://www.w3.org/2000/svg" data-type="color" role="presentation" aria-hidden="true" aria-labelledby="svgcid-jmth8bowytdd"><title id="svgcid-jmth8bowytdd"></title>
              <g>
                <path fill="#7E55F6" d="M86.108 86v28h-27V86h27z" data-color="1"></path>
                <path fill="#7E55F6" d="M141.108 56v28h-28V56h28z" data-color="1"></path>
                <path fill="#7E55F6" d="M141.108 116v28h-28v-28h28z" data-color="1"></path>
                <path d="M20.63 20.63v158.74h158.74V20.63H20.63zm156.26 156.26H23.11V23.11h153.78v153.78zm-89.292-75.396 24.803 29.595v13.557h29.764v-29.764h-29.764v12.347l-22.947-27.38 22.947-27.768v13.036h29.764V55.354h-29.764v12.833L87.598 98.201V85.118H57.835v29.764h29.764v-13.388zm27.284 15.868h24.803v24.803h-24.803v-24.803zm0-59.527h24.803v24.803h-24.803V57.835zm-27.04 42.019-.243.204v-.405l.243.201zm-2.724 12.548H60.315V87.598h24.803v24.804z" fill="#1D1D1B" data-color="2"></path>
              </g>
            </svg>
            <div className="ml-10 mt-5 mb-20">
              <p className="mb-5 text-2xl">Knowledge</p>
              <p>I'm a paragraph. Click</p>
              <p>here to add your own</p>
              <p>text and edit me.</p>
            </div>
          </div>
          <div className="border" style={{width: "300px"}}>
            <svg className="ml-10 mt-20" preserveAspectRatio="xMidYMid meet" data-bbox="20.63 20.63 158.74 158.74" viewBox="20.63 20.63 158.74 158.74" height="70" width="70" xmlns="http://www.w3.org/2000/svg" data-type="color" role="presentation" aria-hidden="true" aria-labelledby="svgcid-fzj42-ibs8jh"><title id="svgcid-fzj42-ibs8jh"></title>
              <g>
                <path fill="#7E55F6" d="m95.809 59 1 52h28l7 7 6-6h10V59h-52z" data-color="1"></path>
                <path d="M20.63 20.63v158.74h158.74V20.63H20.63zm156.26 156.26H23.11V23.11h153.78v153.78z" fill="#1D1D1B" data-color="2"></path>
                <path d="M95.039 57.835v22.323H50.394v54.567h11.435l6.649 7.441 7.124-7.441h29.358v-22.323h19.437l7.124 7.441 6.649-7.441h11.435V57.835H95.039zm7.441 74.409H74.544l-.732.765-5.27 5.504-4.863-5.442-.74-.828H52.874V82.638h42.165v29.764h7.441v19.842zm44.646-22.323h-10.065l-.74.828-4.863 5.442-5.27-5.504-.732-.765H97.52V60.315h49.606v49.606z" fill="#1D1D1B" data-color="2"></path>
              </g>
            </svg>
            <div className="ml-10 mt-5 mb-20">
              <p className="mb-5 text-2xl">Commitment</p>
              <p>I'm a paragraph. Click</p>
              <p>here to add your own</p>
              <p>text and edit me.</p>
            </div>
          </div>
          <div className="border" style={{width: "300px"}}>
            <svg className="ml-10 mt-20" preserveAspectRatio="xMidYMid meet" data-bbox="20.63 20.63 158.74 158.74" viewBox="20.63 20.63 158.74 158.74" height="70" width="70" xmlns="http://www.w3.org/2000/svg" data-type="color" role="presentation" aria-hidden="true" aria-labelledby="svgcid-e8z0cc-tzenpt"><title id="svgcid-e8z0cc-tzenpt"></title>
              <g>
                <path fill="#7E55F6" d="M109.086 91v18h-18V91h18z" data-color="1"></path>
                <path d="M62.086 62v76h76V62h-76zm59 59h-42V79h42v42z" fill="#7E55F6" data-color="1"></path>
                <path d="m139.685 63.429 7.594-7.484.049.184 19.133-5.044-.635-2.398-15.266 4.025 6.646-6.55-1.739-1.766-6.338 6.247 3.455-15.006-2.417-.557-4.331 18.809-6.521 6.427h-79v79.37h79.37V63.429zm-76.89 73.776v-74.41h74.002l-15.099 14.882H77.677v44.646h44.646V80.541l14.882-14.668v71.331h-74.41zm46.321-47.126H90.079v19.843h19.843V92.764l9.921-9.779v36.857H80.157V80.157h39.024l-10.065 9.922zm-8.464 11.822 6.789-6.692v12.232H92.559V92.559h14.04l-7.686 7.576 1.739 1.766zM20.63 20.63v158.74h158.74V20.63H20.63zm156.26 156.26H23.11V23.11h153.78v153.78z" fill="#1D1D1B" data-color="2"></path>
              </g>
            </svg>
            <div className="ml-10 mt-5 mb-20">
              <p className="mb-5 text-2xl">Passion</p>
              <p>I'm a paragraph. Click</p>
              <p>here to add your own</p>
              <p>text and edit me.</p>
            </div>
          </div>
        </div>
        <div className="my-20 flex flex-col justify-center text-center">
          <p className="text-6xl">We Work With the Very Best</p>
          <p className="text-5xl mt-20 font-thin">Sponsor Logos Here</p>
        </div>
      </div>
      <Footer/>
    </div>
  )
}

export default AboutUs